import { ClientsInfoMappingConfig } from '@src/config/baseAppConfig.types';

export default {
  clientsInfo: {
    '1febe974-ca4f-44c1-9fc8-bafbd3bb4abd': { name: 'EO Browser' },
    '0f61d385-5c8b-44f9-a154-2adf51d50141': { name: 'Requests Builder' },
  },
} as ClientsInfoMappingConfig;
